
function setCssSupport() {
  if(!window.CSS) {
    window.CSS = {};
  }
  if(!window.CSS.supports) {
    window.CSS.supports = function() {
        return false;
    };
  }
}

function setConsoleLog() {
  if(!window.console && !window.console.log) {
    window.console = {
      log: function() {}
    }
  }
}

setCssSupport();
setConsoleLog();
